<script>
    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let errorMsg = null
    export let name = null
    export let valid = false
    export let placeholder = ''
    export let info = null
    export let validationsLvls = ['Mala', 'Buena', 'Muy Buena']
    export let validations = []
    let focus
    let input
    let showPassword = false
    export let signUp = false
    import { Typography } from './'
    import { getContext, onDestroy } from 'svelte'
    import { InfoOutline } from '../Icons'
    import { createEventDispatcher } from 'svelte'
    import ShowEye from '../Icons/custom/ShowEye.svelte'
    import HideEye from '../Icons/custom/HideEye.svelte'
    const dispatch = createEventDispatcher()
    function onchange() {
        dispatch('change', {})
    }
    function onkeypress() {
        dispatch('keypress', {})
    }
    function onkeyup(event) {
        dispatch('keyup', { event })
    }
    function onblur() {
        dispatch('blur', {})
    }
    let formData = getContext('formData')
    $: if (value) {
        valid = value && validation ? validation(value) : null
    }
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value,
                            label,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    function setType(type) {
        input.type = type
    }
    $: validatePercent = validations
        ? validations.filter((v) => v.func(value)).length / validations.length
        : 0
    $: ValidationStatus = validations
        ? validationsLvls[
              Math.round(
                  (validations.length / (validationsLvls.length - 1)) *
                      validatePercent
              )
          ]
        : ''
    $: if (!valid && validations.length > 0) {
        valid = validatePercent === 1
    }
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<div
    class="box"
    class:disabled
    on:mouseover={(_) => (focus = true)}
    on:mouseleave={(_) => (focus = false)}
>
    {#if label}
        <label for={name}>
            <div
                style="position: relative; display: flex; gap: 7px; align-items: center; margin-bottom: 16px"
            >
                <Typography
                    style="margin: 0 0 0 0;"
                    type="caption"
                    color={disabled ? 'grey-300' : 'black'}>{label}</Typography
                >
                {#if required && !disabled && !value}
                    <InfoOutline
                        size={16}
                        title="Campo requerido"
                        style="cursor: pointer"
                    />
                {/if}
            </div>
        </label>
    {/if}
    <div
        style="position: relative; display: flex; gap: 12px; justify-content: space-between; align-items: center; width: 100%"
    >
        <input
            id={name}
            type="password"
            on:change={onchange}
            on:keypress={onkeypress}
            on:keyup={onkeyup}
            on:blur={onblur}
            on:focus={(_) => (focus = true)}
            on:blur={(_) => (focus = false)}
            {name}
            {disabled}
            {placeholder}
            bind:value
            bind:this={input}
        />
        <i
            style="cursor: pointer"
            on:click={(_) => {
                showPassword = !showPassword
                if (showPassword) {
                    setType('text')
                } else {
                    setType('password')
                }
            }}
        >
            {#if showPassword}
                <HideEye color={focus ? '#C5281C' : '#6F7072'} />
            {:else}
                <ShowEye color={focus ? '#C5281C' : '#6F7072'} />
            {/if}
        </i>
    </div>
    <span
        class={!valid && validation && value && !disabled
            ? 'error'
            : focus
              ? 'focus'
              : ''}
        style={(!valid && errorMsg && !disabled) || info
            ? 'padding: 11px 0;'
            : ''}
    >
        {#if value && validation && !valid && errorMsg && !disabled}
            <Typography type="label" style="margin: 0">{errorMsg}</Typography>
        {:else if info && !disabled}
            <Typography type="caption" color="grey-300" style="margin: 0"
                >{info}</Typography
            >
        {/if}
        {#if signUp && validations.length > 0}
            <div class="validationsBox">
                <p>
                    <Typography color="grey-800" type="caption"
                        >Contraseña:</Typography
                    >
                    <Typography
                        style={`font-weight: 800;color: ${'Mala' == ValidationStatus ? '#E9573D' : '#7ED321'}`}
                        type="caption">{ValidationStatus}</Typography
                    >
                </p>
                <ul>
                    {#each validations.filter((i) => 'helper' in i) as v}
                        <li>
                            <svg
                                width="13"
                                height="13"
                                viewBox="0 0 13 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clip-path="url(#clip0)">
                                    {#if v.func(value)}
                                        <path
                                            d="M6.25 0C2.79855 0 0 2.79855 0 6.25C0 9.70145 2.79855 12.5 6.25 12.5C9.70145 12.5 12.5 9.70145 12.5 6.25C12.5 2.79855 9.70145 0 6.25 0Z"
                                            fill="#7ED321"
                                        ></path>
                                        <path
                                            d="M9.45633 4.16016L5.5752 9.14063C5.5445 9.17132 5.49428 9.23828 5.4329 9.23828C5.36872 9.23828 5.32687 9.19364 5.2906 9.15737C5.25432 9.12109 3.08915 7.03962 3.08915 7.03962L3.04729 6.99777C3.03055 6.97266 3.0166 6.94196 3.0166 6.90848C3.0166 6.875 3.03055 6.84431 3.04729 6.8192C3.05845 6.80804 3.06682 6.79967 3.07799 6.78571C3.29283 6.55971 3.7281 6.10212 3.756 6.07422C3.79227 6.03795 3.82296 5.99051 3.88993 5.99051C3.95968 5.99051 4.00432 6.04911 4.03781 6.08259C4.07129 6.11607 5.29339 7.29074 5.29339 7.29074L8.39886 3.30078C8.42676 3.27846 8.46024 3.26172 8.49651 3.26172C8.53278 3.26172 8.56627 3.27567 8.59417 3.29799L9.44796 3.97042C9.47029 3.99833 9.48424 4.03181 9.48424 4.06808C9.48703 4.10435 9.47308 4.13504 9.45633 4.16016Z"
                                            fill="white"
                                        ></path>
                                    {:else}
                                        <path
                                            d="M0.5 6.25C0.5 3.07469 3.07469 0.5 6.25 0.5C9.42531 0.5 12 3.07469 12 6.25C12 9.42531 9.42531 12 6.25 12C3.07469 12 0.5 9.42531 0.5 6.25Z"
                                            fill="white"
                                            stroke={focus
                                                ? '#6F7072'
                                                : '#B0B2B3'}
                                        ></path>
                                        <path
                                            d="M9.45633 4.16016L5.5752 9.14063C5.5445 9.17132 5.49428 9.23828 5.4329 9.23828C5.36872 9.23828 5.32687 9.19364 5.2906 9.15737C5.25432 9.12109 3.08915 7.03962 3.08915 7.03962L3.04729 6.99777C3.03055 6.97266 3.0166 6.94196 3.0166 6.90848C3.0166 6.875 3.03055 6.84431 3.04729 6.8192C3.05845 6.80804 3.06682 6.79967 3.07799 6.78571C3.29283 6.55971 3.7281 6.10212 3.756 6.07422C3.79227 6.03795 3.82296 5.99051 3.88993 5.99051C3.95968 5.99051 4.00432 6.04911 4.03781 6.08259C4.07129 6.11607 5.29339 7.29074 5.29339 7.29074L8.39886 3.30078C8.42676 3.27846 8.46024 3.26172 8.49651 3.26172C8.53278 3.26172 8.56627 3.27567 8.59417 3.29799L9.44796 3.97042C9.47029 3.99833 9.48424 4.03181 9.48424 4.06808C9.48703 4.10435 9.47308 4.13504 9.45633 4.16016Z"
                                            fill={focus ? '#6F7072' : '#B0B2B3'}
                                        ></path>
                                    {/if}
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <rect
                                            width="12.5"
                                            height="12.5"
                                            fill="white"
                                        ></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                            <Typography
                                style="padding: 0; margin: 0"
                                color={focus || v.func(value)
                                    ? 'grey-800'
                                    : 'grey-400'}
                                type="caption">{v.helper}</Typography
                            >
                        </li>
                    {/each}
                </ul>
            </div>
        {/if}
    </span>
</div>

<style>
    .box {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        user-select: none;
    }
    input {
        background: transparent;
        padding: 0 0 11px 0;
        border-style: none;
        margin: 0;
        font-size: 17px;
        width: 90%;
        line-height: 22px;
        color: var(--color-black);
        outline: none;
        caret-color: #5496e3;
    }
    input::placeholder {
        color: var(--color-grey-300);
    }
    input:disabled {
        cursor: no-drop;
    }
    span {
        width: 100%;
        border-top: 1px var(--color-grey-300) solid;
        display: flex;
    }

    span.focus {
        border-top: 1px var(--color-grey-800) solid;
    }

    .error {
        border-top: 1px var(--color-accent-alert-error) solid;
        color: var(--color-accent-alert-error);
        background: var(--color-accent-alert-error-bg);
        border-radius: 0 0 8px 8px;
    }

    .disabled {
        cursor: no-drop;
    }

    .disabled span {
        border-top: 1px var(--color-grey-300) solid;
    }

    .disabled input:disabled {
        color: var(--color-grey-400);
    }
    .validationsBox ul {
        width: 100%;
        position: relative;
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 4px;
    }
    .validationsBox ul li {
        display: flex;
        width: 100%;
        margin: 0;
        padding: 0;
        flex-direction: row;
        gap: 8px;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .validationsBox ul li svg {
        margin: 2px 0 0 0;
        width: 24px;
    }
    .validationsBox p {
        margin: -8px 0 0 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
    }
    input:-webkit-autofill {
        box-shadow: 0 0 0 100px white inset;
    }
</style>
